module.exports = __webpack_public_path__ + "media/images/lb/340-081e40aba9ab9a2ce7f10f8472d3db9f.svg";